import config from './config';
import debugLogging from './debugLogging';


export function profileHasBeenLoaded(profile) {
    debugLogging('executing profileHasBeenLoaded hook', { profile });
    class ProfileHasLoaded extends CustomEvent {
        constructor(profile) {
            super(config.profileLoadedEventName);
            this.profile = profile;
        }
    }

    profile.notifications = profile.notifications || [];

    const _event = new ProfileHasLoaded(profile);
    document.dispatchEvent(_event);
}

export function googleAnalyticsHasMounted() {
    debugLogging('executing googleAnalyticsHasMounted hook');
    class GoogleAnalyticsMounted extends CustomEvent {
        constructor() {
            super(config.googleAnalytics.hasMountedEventName);
        }
    }

    const _event = new GoogleAnalyticsMounted();
    document.dispatchEvent(_event);
}
